'use client';

import { useContext } from "react";
import CustomButton from "../common/buttons/button";
import { usePathname, useRouter } from "next/navigation";
import AuthContext from "@/providers/auth-context";

const exceptions = ["/bejelentkezes", "/regisztracio", "/elfelejtett-jelszo", "/megosztas-elfogadas", "/szolgaltato-bejelentkezes", "/uj-email", "/uj-jelszo", "/uj-regisztracio"];

export default function PublicHeaderButtons({noArrow, onClick = () => {}, mobile}) {
    const path = usePathname();
    const router = useRouter();
    const {setShowLogin, setShowLoginState, setRedirectURL} = useContext(AuthContext);

    const isException = () => {
        let is_exception = false;
        for(let e in exceptions) {
            if(path.startsWith(exceptions[e])) is_exception = true;
        }

        return is_exception;
    }

    const loginClick = () => {
        if(isException()) {
            router.push("/bejelentkezes");
            return;
        }

        onClick();
        setShowLogin(true);
        setShowLoginState("login");
        setRedirectURL(`${window.location.pathname}${window.location.search}`);
    }

    const registrationClick = () => {
        if(isException()) {
            router.push("/regisztracio");
            return;
        }

        onClick();
        setShowLogin(true);
        setShowLoginState("registration");
        setRedirectURL(`${window.location.pathname}${window.location.search}`);
    }

    return <>
        <CustomButton size="md" hierarchy={mobile ? "link-gray" : "tertiary-gray"} onClick={loginClick} rememberSearchParams>
            Bejelentkezés
        </CustomButton>
        <CustomButton size="md" hierarchy={mobile ? "link-gray" : "primary"} icon={noArrow ? undefined : "trailing"} onClick={registrationClick} icon_type="bi-arrow-right" rememberSearchParams>
            Regisztrálok
        </CustomButton>
    </>
}